import {
  getRequest as defaultGetRequest,
  postRequest as defaultPostRequest
} from './request';
import { get } from 'lodash';

const request = () => {
  const innerFun = (defaultRequest) => (...rest) =>
    defaultRequest(...rest).then((response) => {
      const data = get(response, 'data', {});
      if (get(data, 'code') !== 0) {
        return Promise.reject(data);
      }
      return data;
    });
  return {
    get: innerFun(defaultGetRequest),
    post: innerFun(defaultPostRequest)
  };
};

export default request();
